export default __webpack_public_path__ + "static/media/gallery - intro insult_00.48784502.jpg";